import React from 'react';
import useGoogleOptimize from '@react-hook/google-optimize';
const withGoogleOptimize = (WrapperFunction) => {
    function wrapper(props) {
        const cookieConfig = JSON.parse(localStorage.getItem('cookieConfig')) || {};
        const isGoogleCookieRestricted = cookieConfig.analytics && cookieConfig.analytics.includes('analytics_storage'); // check if user restricted google analytics coockie
        console.log(`%cqqq isGoogleCookieRestricted = `, 'font-weight: bold;color: #90ee90', isGoogleCookieRestricted);
        const withGoogleOptimize = useGoogleOptimize('vMRxtZYhTcyzuzxPRBRiBA', [false, true], 1000); // experimentId // ykHwUCskQKejuZqpQZMlWQ // HomePageSearchBtn(1) is set to chance 50/50
        const hasGoogleOptimize = !isGoogleCookieRestricted && withGoogleOptimize;
        return React.createElement(WrapperFunction, { ...props, hasGoogleOptimize });
    }
    return wrapper;
};
export default withGoogleOptimize;
